import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipRecognitionTable = ({ data, type, accidentInsurance, size }) => {
    const { t } = useTranslation();

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>No recognition data available</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Traineeship Type:
                        </Col>
                        <Col>{type || ''}</Col>
                    </Row>
                    {type === "Voluntary" && (
                        <>
                            {/* ECTS Credits Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Award ECTS:
                                </Col>
                                <Col>{data?.field_voluntary_award_ects ? 'Yes' : 'No'}</Col>
                            </Row>
                            {data?.field_voluntary_award_ects && (
                                <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                    <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                        Number of Credits:
                                    </Col>
                                    <Col>{data?.field_voluntary_number_of_credit || ''}</Col>
                                </Row>
                            )}

                            {/* Grades and Recognition Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Give Grades:
                                </Col>
                                <Col>{data?.field_voluntary_give_grades ? 'Yes' : 'No'}</Col>
                            </Row>
                            {data?.field_voluntary_give_grades && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Traineeship Certificate:
                                        </Col>
                                        <Col>{data?.field_voluntary_tr_certificate ? 'Yes' : 'No'}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Interview:
                                        </Col>
                                        <Col>{data?.field_voluntary_interview ? 'Yes' : 'No'}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Final Report:
                                        </Col>
                                        <Col>{data?.field_voluntary_final_report ? 'Yes' : 'No'}</Col>
                                    </Row>
                                </>
                            )}

                            {/* Transcript Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                Transcript:
                                </Col>
                                <Col>{data?.field_voluntary_transcript ? 'Yes' : 'No'}</Col>
                            </Row>

                            {/* Europass Mobility Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Europass Mobility:
                                </Col>
                                <Col>{data?.field_voluntary_europass ? 'Yes' : 'No'}</Col>
                            </Row>
                        </>
                    )}
                    {type === "Embedded" && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Awarded ECTS Credits:
                                </Col>
                                <Col>{data?.field_embedded_award_ects || ''}</Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Traineeship Certificate:
                                </Col>
                                <Col>{data?.field_embedded_tr_certificate ? 'Yes' : 'No'}</Col>
                            </Row>
                            {data?.field_embedded_tr_certificate && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Interview:
                                        </Col>
                                        <Col>{data?.field_embedded_interview ? 'Yes' : 'No'}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Final Report:
                                        </Col>
                                        <Col>{data?.field_embedded_final_report ? 'Yes' : 'No'}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Europass Mobility:
                                </Col>
                                <Col>{data?.field_embedded_europass ? 'Yes' : 'No'}</Col>
                            </Row>
                        </>
                    )}
                    {type === "Graduate" && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Award ECTS:
                                </Col>
                                <Col>{data?.field_recent_award_ects ? 'Yes' : 'No'}</Col>
                            </Row>
                            {data?.field_recent_award_ects && (
                                <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                    <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                        Number of Credits:
                                    </Col>
                                    <Col>{data?.field_recent_number_of_credits || ''}</Col>
                                </Row>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Europass Mobility:
                                </Col>
                                <Col>{data?.field_recent_europass ? 'Yes' : 'No'}</Col>
                            </Row>
                        </>
                    )}
                    
                    {/* Accident Insurance Section */}
                    {accidentInsurance && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}>
                                    <strong>Accident Insurance for the Trainee</strong>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Accident Insurance:
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins ? 'Yes' : 'No'}</Col>
                            </Row>
                            {accidentInsurance?.field_acc_ins && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Coverage on the Way:
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_way ? 'Yes' : 'No'}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Coverage During Travel:
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_travel ? 'Yes' : 'No'}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Liability Insurance:
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins_liability ? 'Yes' : 'No'}</Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipRecognitionTable;